import s from "../cargo-moderator/styles.module.css";
import { Button, message } from "antd";
import React, { useState } from "react";
import { useAddMistakeOrder } from "../../api/1688-order-info/hooks";
import CustomModal from "../UI/Modal/Modal";
import CargoTable from "../cargo-moderator/cargo-table/cargo-table";
import { NotifModal } from "./libs/modal-notif";
import { useTranslation } from 'react-i18next';


export function SixteenEightyEightOrderInfo({ translation, language }) {
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [notifOpen, setNotifOpen] = useState(false);
    const { t } = useTranslation();

    const [inputData, setInputData] = useState({
        track_code: "",
        id_code: "",
    });

    const [tableOrder, setTableOrder] = useState({
        content: [],
        totalPages: 0,
    });

    const [page, setPage] = useState(0);
    const [number, setNumber] = useState(10);

    const { mutate: addOrder, isLoading } = useAddMistakeOrder();

    const showModal = () => setAddModalOpen(true);
    const handleCancel = () => setAddModalOpen(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputData((prev) => ({ ...prev, [name]: value }));
    };

    const handleAddOrder = () => {
        if (!inputData.track_code || !inputData.id_code) {
            message.warning(t("fillAllFields"));
            return;
        }

        addOrder(
            {
                trackCode: inputData.track_code,
                ownerLessCode: inputData.id_code,
            },
            {
                onSuccess: (data) => {
                    setTableOrder({
                        content: [data],
                        totalPages: 1,
                    });

                    setAddModalOpen(false);
                    setInputData({ track_code: "", id_code: "" });
                    setNotifOpen(true);
                },
                onError: (error) => {
                    message.error(
                        error?.response?.data?.message ||
                        t("trackCodeAddError")
                    );
                },
            }
        );
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleChangeSelector = (value) => {
        setNumber(value);
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                padding: "0 40px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "24px",
                }}
            >
                <h1 className={s["title-text"]}>
                    {t("fetchOrderInfo")}
                </h1>

                <Button
                    onClick={showModal}
                    style={{
                        background: "#100E71",
                        color: "#fff",
                        fontSize: "16px",
                        borderRadius: "12px",
                        width: "200px",
                    }}
                >
                    {t("addTrackCode")}
                </Button>
            </div>

            <CustomModal
                visible={addModalOpen}
                onOk={handleAddOrder}
                onClose={handleCancel}
            >
                <h1 style={{ marginBottom: "24px" }}>
                    {t("addProductInfo")}
                </h1>

                <input
                    name="track_code"
                    value={inputData.track_code}
                    onChange={handleInputChange}
                    placeholder={t("enterTrackCodeCh")}
                    style={{
                        width: "100%",
                        borderRadius: "8px",
                        padding: "24px",
                        fontSize: "16px",
                        marginBottom: "8px",
                    }}
                />

                <input
                    name="id_code"
                    value={inputData.id_code}
                    onChange={handleInputChange}
                    placeholder={t("enterIdCodeCh")}
                    style={{
                        width: "100%",
                        borderRadius: "8px",
                        padding: "24px",
                        fontSize: "16px",
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        gap: "14px",
                        marginTop: "24px",
                    }}
                >
                    <Button
                        loading={isLoading}
                        onClick={handleCancel}
                        style={{ width: "100%", height: "40px" }}
                    >
                        {t("cancelCh")}
                    </Button>
                    <Button
                        loading={isLoading}
                        onClick={handleAddOrder}
                        style={{ width: "100%", height: "40px" }}
                    >
                        {t("add")}
                    </Button>
                </div>
            </CustomModal>

            <CargoTable
                translation={translation}
                language={language}
                page={page}
                setPage={handlePageChange}
                number={number}
                ordersData={tableOrder.content}
                tableOrder={tableOrder}
                handleChange={handleChangeSelector}
                role="RoleChina"
                refetch={() => {}}
                setDataBarcode={setTableOrder}
            />

            <NotifModal number="1" open={notifOpen} onClose={() => setNotifOpen(false)} />
        </div>
    );
}
